import { QuizQuestion } from '../../api/quiz-services';

export const assessmentMetadata = {
    title: "Module 3: Basic Control Tasks Quiz",
    duration: 15
};

export const module3Questions: QuizQuestion[] = [
    {
        id: "M3-001",
        moduleId: "module-3",
        category: "Ergonomics",
        text: "Your seat should be adjusted so your knee has a ____ bend when the brake is depressed.",
        options: ["0 degree (Locked)", "15-20 degree", "45 degree", "90 degree"],
        correctAnswer: 1,
        scenario: "Your seat should be adjusted so your knee maintains a **15-20 degree bend** when the brake pedal is depressed. A locked, straight leg behaves like a rigid rod in a frontal crash, directing all impact energy directly through your bones to cause severe fractures. A bent knee acts as a natural shock absorber, absorbing crash forces safely.",
        explanation: ""
    },
    {
        id: "M3-002",
        moduleId: "module-3",
        category: "Controls",
        text: "The 'Pivot Point' means your ____ should remain on the floor between the pedals.",
        options: ["Right toe", "Right heel", "Left foot", "Overall leg"],
        correctAnswer: 1,
        scenario: "The 'Pivot Point' technique means the **heel of your right foot must remain on the floor** between the brake and accelerator pedals. You pivot the ball of your foot back and forth to transition between pedals without lifting your leg. This technique ensures rapid, highly precise pedal control and reduces response time in emergencies.",
        explanation: ""
    },
    {
        id: "M3-003",
        moduleId: "module-3",
        category: "Safety",
        text: "Why should you tilt the steering wheel toward your chest rather than your face?",
        options: ["Better visibility", "To see the speedo", "To protect head/neck from airbag impact", "Comfort"],
        correctAnswer: 2,
        scenario: "You must tilt the steering wheel toward your chest because **your chest/ribcage is a strong skeletal structure** that can absorb impact forces. If the wheel is tilted toward your face, the expanding airbag will strike your head and neck at 200+ MPH, which can cause fatal cervical fractures or severe facial trauma.",
        explanation: ""
    },
    {
        id: "M3-004",
        moduleId: "module-3",
        category: "Diagnostics",
        text: "What does P.O.S.T. stand for in vehicle diagnostics?",
        options: ["Power-On Self-Test", "Primary Operating System Trail", "Plug-On System Tool", "Pilot Operation Safety Test"],
        correctAnswer: 0,
        scenario: "P.O.S.T. stands for **Power-On Self-Test**. It is a rapid diagnostic check performed automatically by the vehicle's onboard computers when you switch the ignition to ON. It verifies that critical safety sensors, airbags, braking actuators, and engine components are communicating and fully operational.",
        explanation: ""
    },
    {
        id: "M3-005",
        moduleId: "module-3",
        category: "Diagnostics",
        text: "If a warning light stays on after the 3-second 'Indicator Sweep', it means:",
        options: ["The light bulb is stuck", "The system is warming up", "A fault has been detected", "It is scheduled for a test"],
        correctAnswer: 2,
        scenario: "If a warning light remains illuminated after the initial startup diagnostics sweep, it indicates that the computer has **detected an active fault or malfunction** in that system. Safe pilots should never ignore persistent alerts and must have the vehicle inspected immediately.",
        explanation: ""
    },
    {
        id: "M3-006",
        moduleId: "module-3",
        category: "Controls",
        text: "Which gear selector position is required to start the engine in most modern cars?",
        options: ["Neutral (N)", "Drive (D)", "Park (P)", "Reverse (R)"],
        correctAnswer: 2,
        scenario: "To start the engine, the gear selector must be in **Park (P)** (or Neutral in manual transmissions). This is a vital mechanical lockout safety feature that prevents the starter motor from activating when the transmission is in a drive gear, ensuring the vehicle cannot lunge forward or backward upon starting.",
        explanation: ""
    },
    {
        id: "M3-007",
        moduleId: "module-3",
        category: "Safety",
        text: "The Brake-Shift Interlock requires you to ____ before shifting out of Park.",
        options: ["Turn on headlights", "Release the parking brake", "Depress the service brake", "Signal your intent"],
        correctAnswer: 2,
        scenario: "The Brake-Shift Interlock is an essential safety feature that requires you to **depress the service brake pedal** before you can shift the gear selector out of Park (P). This prevents the vehicle from rolls or sudden lunges, ensuring the driver has full physical control over the service brakes before the transmission engages.",
        explanation: ""
    },
    {
        id: "M3-008",
        moduleId: "module-3",
        category: "Controls",
        text: "What is the recommended hand position on the steering wheel for maximum control and airbag safety?",
        options: ["10 and 2", "9 and 3", "12 and 6", "Hand-over-hand only"],
        correctAnswer: 1,
        scenario: "You are adjusting your seat and positioning your hands on the steering wheel before starting your drive.",
        explanation: "Under standard safety guidelines, positioning your hands at 9 and 3 on the steering wheel provides optimal turning leverage and keeps your hands and arms completely clear of the steering wheel's center airbag module in the event of an explosive 200 mph deployment."
    },
    {
        id: "M3-009",
        moduleId: "module-3",
        category: "Habits",
        text: "The standard following distance behind another vehicle in ideal conditions is:",
        options: ["1-2 seconds", "3-4 seconds", "100 feet", "Double the speed limit"],
        correctAnswer: 1,
        scenario: "You are driving behind another vehicle on a dry municipal highway under ideal conditions and want to establish a safe following buffer.",
        explanation: "Maintaining a minimum 3-to-4-second following distance under ideal conditions provides an adequate time cushion to react, scan, and safely bring your vehicle's mass to a stop if the lead car brakes suddenly."
    },
    {
        id: "M3-010",
        moduleId: "module-3",
        category: "Safety",
        text: "A slight vibration or pulsing in the brake pedal during an emergency stop usually means:",
        options: ["Brakes are failing", "Tires are flat", "ABS is actively preventing wheel lockup", "The engine is stalling"],
        correctAnswer: 2,
        scenario: "You execute a sudden emergency stop on a wet roadway, and the service brake pedal begins to vibrate and pulse violently under your foot.",
        explanation: "Pedal pulsing is the standard mechanical feedback that your Anti-lock Braking System is actively pulsing the brakes to prevent tire lockup, allowing you to maintain steering control. Keep pressing firmly and never release the pedal!"
    },
    {
        id: "M3-011",
        moduleId: "module-3",
        category: "Habits",
        text: "When entering an unfamiliar vehicle, you should always perform a ____ start sequence.",
        options: ["Rapid", "Diagnostic-only", "Systematic", "Random"],
        correctAnswer: 2,
        scenario: "When entering an unfamiliar vehicle, you must always perform a **systematic pre-start and startup sequence**. This includes adjusting the seating column ergonomics first, adjusting all rearview and BGE mirrors, locating the headlights and accessory controls, setting the GPS, and identifying dashboard symbols before turning the key.",
        explanation: ""
    },
    {
        id: "M3-012",
        moduleId: "module-3",
        category: "Ergonomics",
        text: "The head restraint should be positioned within ____ inches of the back of your head.",
        options: ["0 (Touching)", "2-4 inches", "5-8 inches", "As far as possible"],
        correctAnswer: 1,
        scenario: "The head restraint should be positioned **within 2-4 inches** of the back of your head. If the distance is greater than 4 inches, your head will travel too far backward before meeting the restraint, which dramatically increases the risk of severe whiplash in a rear-end collision.",
        explanation: ""
    },
    {
        id: "M3-013",
        moduleId: "module-3",
        category: "Controls",
        text: "Maintaining a ____ grip on the wheel improves feedback from the road.",
        options: ["Death", "White-knuckle", "Relaxed but firm", "One-handed"],
        correctAnswer: 2,
        scenario: "You are steering your vehicle down a rough, grooved asphalt roadway. A passenger asks why you maintain a relaxed but firm grip instead of gripping it tightly.",
        explanation: "A relaxed but firm grip prevents muscle fatigue and allows your hands to feel structural feedback and minor vibrations from the road, ensuring high steering precision and lane stability."
    },
    {
        id: "M3-014",
        moduleId: "module-3",
        category: "Safety",
        text: "Airbags are designed to work WITH ____, not as a replacement for them.",
        options: ["Headlights", "Seatbelts", "ABS", "ESC"],
        correctAnswer: 1,
        scenario: "Airbags are designed to work **only in combination with seatbelts**, not as a replacement. If you are unbuckled, the crash forces will throw you forward into the airbag while it is still expanding with explosive force, causing severe injuries. Seatbelts keep your body in the correct posture to receive the cushioning force of the deflating airbag safely.",
        explanation: ""
    },
    {
        id: "M3-015",
        moduleId: "module-3",
        category: "Dashboard",
        text: "A BLUE status light on the dashboard indicates:",
        options: ["Low fuel", "Oil pressure loss", "High beams are on", "Fog lights active"],
        correctAnswer: 2,
        scenario: "While driving at night, you notice a bright BLUE indicator light illuminated on your instrument panel.",
        explanation: "Answer: A BLUE status light on the dashboard indicates that your high-beam headlights are active. High beams project a bright, long-range light pattern that can severely blind oncoming drivers. You must immediately switch to low beams when an oncoming vehicle is within 500 feet, or when following another vehicle within 300 feet (Ohio OAC 4501-7 compliance rule)."
    },
    {
        id: "M3-016",
        moduleId: "module-3",
        category: "Maintenance",
        text: "If your battery light stays on while driving, you likely have ____ of power remaining.",
        options: ["5 minutes", "15-30 minutes", "2 hours", "Indefinite"],
        correctAnswer: 1,
        scenario: "If the red battery warning light remains on, it indicates a charging system failure, meaning the alternator is not recharging the battery. The vehicle will run entirely off the battery's stored energy, leaving you with only **15-30 minutes** of total operational power before the engine stalls and all safety systems lose power.",
        explanation: ""
    },
    {
        id: "M3-017",
        moduleId: "module-3",
        category: "Controls",
        text: "Smoothly increasing and decreasing pedal pressure is known as ____.",
        options: ["Stomping", "Squeezing", "Feathering", "Pumping"],
        correctAnswer: 2,
        scenario: "You are decelerating smoothly for an upcoming red traffic signal and want to maintain suspension and weight equilibrium.",
        explanation: "Smoothly increasing and then gradually releasing (feathering) pedal pressure shifts the vehicle's weight uniformly, preventing the suspension from 'pitching' forward and stabilizing the tires' contact patches."
    },
    {
        id: "M3-018",
        moduleId: "module-3",
        category: "Diagnostics",
        text: "Every warning light should illuminate for ____ seconds during the initial start diagnostic.",
        options: ["1", "2-3", "10", "Only until the engine starts"],
        correctAnswer: 1,
        scenario: "Every warning light should illuminate for **2-3 seconds** during the initial indicator sweep self-test. This brief diagnostic period lets the driver visually verify that the system check is actively running and that the indicator bulbs themselves are functioning properly.",
        explanation: ""
    },
    {
        id: "M3-019",
        moduleId: "module-3",
        category: "Habits",
        text: "Visual literacy refers to the ability to quickly decode ____.",
        options: ["Radio stations", "Dashboard symbols", "License plates", "GPS maps"],
        correctAnswer: 1,
        scenario: "Visual literacy is the pilot's ability to **quickly decode and understand dashboard symbols and safety alerts**. Recognizing what these icons mean instantly allows you to take prompt, correct emergency actions, avoiding catastrophic damage to the vehicle's mechanics and maintaining passenger safety.",
        explanation: ""
    },
    {
        id: "M3-020",
        moduleId: "module-3",
        category: "Safety",
        text: "The center of the head restraint should be level with ____.",
        options: ["The top of your head", "The top of your ears", "The eyes", "The neck"],
        correctAnswer: 1,
        scenario: "The center of the head restraint must be adjusted vertically until it is **level with the top of your ears**. This ensures that the primary mass of your head is supported during a rear-end impact, preventing the head from snapping back over the restraint.",
        explanation: ""
    },
    {
        id: "M3-021",
        moduleId: "module-3",
        category: "Turning",
        text: "When preparing to make a turn, at what minimum distance should you activate your turn signal in a residential area?",
        options: ["50 feet", "100 feet", "200 feet", "500 feet"],
        correctAnswer: 1,
        scenario: "**Correct Action**: **In Ohio, you must signal your intent to turn at least 100 feet before the turn in residential or business areas, giving motorists behind you ample warning.**",
        explanation: ""
    },
    {
        id: "M3-022",
        moduleId: "module-3",
        category: "Parking",
        text: "When parking uphill against a curb, in which direction should you turn your front wheels?",
        options: ["Straight ahead", "Toward the curb", "Away from the curb", "It does not matter"],
        correctAnswer: 2,
        scenario: "**Correct Action**: **When parking uphill against a curb, turn your front wheels away from the curb (toward the street). If the car rolls backward, the tires will block against the curb, preventing it from rolling into traffic.**",
        explanation: ""
    },
    {
        id: "M3-023",
        moduleId: "module-3",
        category: "Control",
        text: "What is 'push-pull' steering primarily recommended for in driver safety?",
        options: [
            "High-speed highway lane changes",
            "Smooth, low-speed turns where hands do not cross and hands stay on the wheel",
            "Emergency skid recovery",
            "Parallel parking only"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **Push-pull steering is recommended for smooth, standard turns because it keeps both hands on opposite sides of the wheel at all times, reducing risk of arm injury during airbag deployment.**",
        explanation: ""
    },
    {
        id: "M3-024",
        moduleId: "module-3",
        category: "Backing",
        text: "When backing a vehicle straight, where should your head and eyes be directed?",
        options: [
            "Strictly at the rear-view mirror",
            "Glanced down at the dashboard backup camera screen only",
            "Turned over your right shoulder looking directly out the rear window",
            "Strictly out the driver's side window"
        ],
        correctAnswer: 2,
        scenario: "**Correct Action**: **When backing straight, look directly over your right shoulder through the rear window. Mirrors and backup cameras have visual limitations and blind spots, making physical over-the-shoulder scanning the safest technique.**",
        explanation: ""
    },
    {
        id: "M3-025",
        moduleId: "module-3",
        category: "Maneuvers",
        text: "What is the safest way to execute a 3-point turn (Y-turn)?",
        options: [
            "On a high-speed busy state route",
            "Only in low-traffic areas, ensuring clear visibility in both directions before starting",
            "Without using the brakes",
            "Backward first"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **A 3-point turn should only be performed in low-traffic areas with excellent visibility in both directions. Never attempt this maneuver on busy highways, curves, or near hilltops where oncoming cars cannot see you.**",
        explanation: ""
    }
];
